import { Spinner } from "../../utils/Spinner";

type ButtonColor = "red" | "gray" | "blue";
interface BigBlueButtonProps {
  color?: ButtonColor;
  dataTourId: string;
  disabled?: boolean;
  Icon?: React.ComponentType<{ className?: string }>;
  onClick: () => void;
  showSpinner?: boolean;
  textLine1: string;
  textLine2?: string;
}

export function BigBlueButton({
  dataTourId,
  color,
  onClick,
  textLine1,
  textLine2,
  Icon,
  disabled = false,
  showSpinner = false,
}: BigBlueButtonProps) {
  const buttonColor =
    color === "red"
      ? "bg-red-600 hover:bg-red-500"
      : color === "gray"
      ? "bg-gray-400"
      : "bg-main-button hover:bg-main-button-hover";

  return (
    <button
      data-tour-id={dataTourId}
      type="button"
      className={`rounded-full ${buttonColor} px-4 py-2.5 text-md font-semibold text-main-button-text shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 h-64 w-64 flex flex-col justify-center justify-items-center items-center gap-y-4`}
      onClick={onClick}
      disabled={disabled}
    >
      {showSpinner && <Spinner size="h-10 w-10" timer={false} />}
      {textLine1 && <span className="text-white text-xl font-semibold">{textLine1}</span>}
      {textLine2 && <span className="text-white text-xl font-semibold">{textLine2}</span>}
      {Icon && <Icon className="h-10" />}
    </button>
  );
}
